



















import Vue from "vue";

export interface FlexProperty {
  name: string;
  id: string;
  appliedToChildren: boolean;
  values: string[];
}

export default Vue.extend({
  name: "PropertySelector",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: String,
    property: Object as () => FlexProperty
  }
});
